/**
 * Apple-Style Spring Physics Configuration
 * 
 * Based on Apple's Human Interface Guidelines and Framer Motion best practices.
 * All animations should use these spring presets for natural, bouncy feel.
 */

export const appleSprings = {
  /**
   * Standard interactions (buttons, cards, hover states)
   * Stiffness: 300, Damping: 25 - Natural bounce without overshoot
   */
  standard: {
    type: "spring" as const,
    stiffness: 300,
    damping: 25,
    mass: 0.5,
  },

  /**
   * Quick interactions (micro-interactions, hover states)
   * Stiffness: 400, Damping: 30 - Snappy but still natural
   */
  quick: {
    type: "spring" as const,
    stiffness: 400,
    damping: 30,
    mass: 0.3,
  },

  /**
   * Smooth transitions (page transitions, large movements)
   * Stiffness: 200, Damping: 25 - Gentle, flowing motion
   */
  smooth: {
    type: "spring" as const,
    stiffness: 200,
    damping: 25,
    mass: 0.8,
  },

  /**
   * Mobile-optimized (softer, more gentle for touch)
   * Stiffness: 250, Damping: 30 - Softer feel for mobile devices
   */
  mobile: {
    type: "spring" as const,
    stiffness: 250,
    damping: 30,
    mass: 0.6,
  },

  /**
   * Scale interactions (buttons, cards on hover/tap)
   * Optimized for scale transforms
   */
  scale: {
    type: "spring" as const,
    stiffness: 400,
    damping: 25,
    mass: 0.4,
  },
} as const;

/**
 * Staggered animation helpers for Apple-style sequential appearance
 */
export const createStaggeredContainer = (delay: number = 0.08) => ({
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: delay,
      delayChildren: 0.1,
    },
  },
});

export const createStaggeredItem = (springConfig = appleSprings.standard) => ({
  hidden: {
    opacity: 0,
    y: 20,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: springConfig,
  },
});

